import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import CustomStepper from "./Stepper";
import "../SignupPages/SignupCommon.css";

const NewSignupPage2: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };

  const location = useLocation(); // ✅

  // ✅ Safe navigate function to avoid duplicate replaceState
  const safeNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path, { replace: true });
    }
  };

  useEffect(() => {
    const step1Completed = localStorage.getItem("step-1-completed");
    if (step1Completed) {
      safeNavigate("/getting-started/step-2");
    } else {
      safeNavigate("/getting-started/step-1");
    }
  }, []);

  const handleNext = () => {
    if (selectedOption) {
      localStorage.setItem(
        "past_illness",
        JSON.stringify({
          key: "past_illness",
          value: selectedOption,
          id: 18026058,
        })
      );
    }
    if (selectedOption === "None of the Following") {
      navigate("/getting-started/step-3");
    } else {
      navigate("/getting-started/invalid-age");
    }
    localStorage.setItem("step-2-completed", "true");
  };
  const navigate = useNavigate();

  useEffect(() => {
    const savedPastIllness = localStorage.getItem("past_illness");

    if (savedPastIllness) {
      const parsedPastIllness = JSON.parse(savedPastIllness);
      setSelectedOption(parsedPastIllness.value);
    }
  }, []);

  const options = [
    "None of the Following",
    "End-stage kidney disease",
    "End-stage liver disease",
    "Current suicidal thoughts and/or prior suicidal attempt",
    "Cancer",
    "History of Organ Transplant on anti-rejection medication",
    "Severe gastrointestinal condition",
    "Current diagnosis of or treatment for alcohol, opioid, or substance use disorder/dependence",
    "Uncontrolled diabetes",
  ];

  const handleBack = () => {
    navigate("/getting-started/step-1");
  };

  return (
    <PageWrapper onBack={handleBack}>
      <div className="signup-page-container container">
        <CustomStepper activeStep={1} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-content-header signup-content-heading-text">
            Do you have any existing health conditions we should be aware of?
          </p>
          <p className="signup-content-header-text">
            (Currently or in past which could impact your health & wellness
            journey)
          </p>
          <div className="options options-box-content">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={!selectedOption}
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NewSignupPage2;
